export default "__VITE_ASSET__B2srr5Pl__"